import { j as o } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { IonButton as i } from "@ionic/react";
import { Colors as m } from "../../../../1-foundations/Colors/Colors.js";
import { I as n } from "../../../../../Icon-D8QUNSZR.js";
import "../../../../../FeatureFlagProvider-CQds873Z.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function u(t) {
  const {
    onClick: r
  } = t;
  return /* @__PURE__ */ o(i, {
    fill: "clear",
    size: "small",
    onClick: r,
    style: {
      margin: 0,
      "--padding-bottom": 0,
      "--padding-top": 0,
      "--padding-start": 0,
      "--padding-end": 0
    },
    children: /* @__PURE__ */ o(n, {
      name: "Edit",
      color: m.blue500
    })
  });
}
export {
  u as ButtonEdit
};
